(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["battle-sp5000-detail-redesign"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBattleSp5000Detail(root) {
      if (!root || root.dataset.battleSp5000Ready === 'true') return;
      root.dataset.battleSp5000Ready = 'true';

      var items = root.querySelectorAll('.battle-sp5000-detail__reveal');
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        items.forEach(function (item) { item.classList.add('is-visible'); });
        return;
      }

      root.classList.add('is-reveal-ready');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });

      items.forEach(function (item) { observer.observe(item); });
    }

    function initAllBattleSp5000Details(scope) {
      var container = scope && scope.querySelectorAll ? scope : document;
      container.querySelectorAll('[data-battle-sp5000-detail]').forEach(initBattleSp5000Detail);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAllBattleSp5000Details(document); });
    } else {
      initAllBattleSp5000Details(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initAllBattleSp5000Details(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.headerBounds = { top: 0, bottom: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (!pastBottom) {
      if (beforeTop) {
        this._setState('reset');
      } else if (scrollTop < this.currentScrollTop) {
        this._setState('revealed');
      } else {
        this._setState('reset');
      }
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hunter-v2"] && !Shopify.designMode) return;
  try {
    
    (function () {
      document.querySelectorAll('[data-hunter-v2-detail]').forEach(function (root) {
        if (root.dataset.hunterV2Initialized === 'true') return;
        root.dataset.hunterV2Initialized = 'true';

        var revealItems = root.querySelectorAll('.hunter-v2__reveal');
        if (!('IntersectionObserver' in window)) {
          revealItems.forEach(function (item) {
            item.classList.add('is-visible');
          });
        } else {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
              }
            });
          }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

          revealItems.forEach(function (item) {
            observer.observe(item);
          });

          root.classList.add('hunter-v2--reveal-ready');
        }

        var tabs = root.querySelectorAll('[data-hunter-v2-mode]');
        var panels = root.querySelectorAll('[data-hunter-v2-panel]');

        tabs.forEach(function (tab) {
          tab.addEventListener('click', function () {
            var mode = tab.getAttribute('data-hunter-v2-mode');

            tabs.forEach(function (item) {
              var active = item === tab;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-selected', active ? 'true' : 'false');
            });

            panels.forEach(function (panel) {
              var active = panel.getAttribute('data-hunter-v2-panel') === mode;
              panel.classList.toggle('is-active', active);
              panel.setAttribute('aria-hidden', active ? 'false' : 'true');
            });
          });
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-about-motion"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-ka-about-motion]');
  if (!roots.length) return;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach((root) => {
    const revealTargets = Array.from(root.querySelectorAll('[data-reveal], .ka-about__story-text p'))
      .filter((node) => !node.classList.contains('ka-about__card'));
    root.classList.add('ka-about--ready');

    const setHeroHover = (active) => {
      root.classList.toggle('ka-about--hero-hover', active);
      root.style.setProperty('--ka-hero-hover', active ? '1' : '0');
      if (!active) {
        root.style.setProperty('--ka-pointer-x', '0');
        root.style.setProperty('--ka-pointer-x-soft', '0px');
      }
    };

    const finalSettleDelay = 2400;
    let finalSettleTimer = null;

    const setFinalVisible = () => {
      root.classList.add('ka-about--final-visible');
      root.style.setProperty('--ka-motion-final', '1');
      if (!root.classList.contains('ka-about--final-settled')) {
        window.clearTimeout(finalSettleTimer);
        finalSettleTimer = window.setTimeout(() => {
          root.classList.add('ka-about--final-settled');
        }, finalSettleDelay);
      }
    };

    const setFinalHover = (active) => {
      root.classList.toggle('ka-about--final-hover', active);
    };

    if (!('IntersectionObserver' in window) || prefersReduced) {
      revealTargets.forEach((node) => node.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

      revealTargets.forEach((node) => observer.observe(node));
    }

    const splitWords = (node, className, collector) => {
      const text = node.textContent.trim();
      node.textContent = '';
      text.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/\s+/.test(part)) {
          node.appendChild(document.createTextNode(part));
          return;
        }
        const word = document.createElement('span');
        word.className = className;
        word.textContent = part;
        node.appendChild(word);
        collector.push(word);
      });
    };

    const heroWords = [];
    const storyWords = [];
    const finalPill = root.querySelector('.ka-about__final-pill');
    Array.from(root.querySelectorAll('[data-hero-line]')).forEach((node) => {
      splitWords(node, 'ka-about__hero-word', heroWords);
    });
    Array.from(root.querySelectorAll('[data-spotlight]')).forEach((node) => {
      splitWords(node, 'ka-about__motion-word', storyWords);
    });

    if (finalPill) {
      finalPill.addEventListener('click', (event) => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: prefersReduced ? 'auto' : 'smooth',
        });

        if (window.location.hash) {
          window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        }
      });
    }

    if (prefersReduced) {
      root.classList.add('ka-about--hero-loaded');
      root.classList.add('ka-about--final-visible');
      root.classList.add('ka-about--final-settled');
      heroWords.concat(storyWords).forEach((word) => word.classList.add('is-lit'));
      root.style.setProperty('--ka-motion-hero', '0');
      root.style.setProperty('--ka-motion-hero-reveal', '1');
      root.style.setProperty('--ka-motion-adaptive', '1');
      root.style.setProperty('--ka-motion-service', '1');
      root.style.setProperty('--ka-motion-proof', '1');
      root.style.setProperty('--ka-motion-final', '1');
      return;
    }

    const hero = root.querySelector('[data-motion-hero]');
    const story = root.querySelector('[data-motion-story]');
    const storyCopy = story ? story.querySelector('.ka-about__origin-copy') : null;
    const adaptive = root.querySelector('[data-motion-adaptive]');
    const service = root.querySelector('[data-motion-service]');
    const proof = root.querySelector('.ka-about__service-proof');
    const final = root.querySelector('[data-motion-final]');
    const heroPill = root.querySelector('[data-hero-pill]');
    let ticking = false;
    const heroIntroStart = performance.now();
    const heroLoadTimer = window.setTimeout(() => {
      root.classList.add('ka-about--hero-loaded');
    }, 500);

    const motionValues = new Map();
    const motionThreshold = 0.002;
    let lastHeroLitCount = -1;
    let lastStoryLitCount = -1;

    const setMotionValue = (property, value) => {
      const next = clamp(value);
      const previous = motionValues.get(property);
      const isBoundary = next === 0 || next === 1;

      if (previous !== undefined) {
        const isSameValue = previous === next;
        const isSmallChange = Math.abs(next - previous) < motionThreshold;
        if (isSameValue || (!isBoundary && isSmallChange)) return;
      }

      motionValues.set(property, next);
      root.style.setProperty(property, next.toFixed(3));
    };

    const syncLitWords = (words, nextCount, previousCount) => {
      if (!words.length) return 0;

      const targetCount = Math.min(words.length, Math.max(0, nextCount));
      if (targetCount === previousCount) return previousCount;

      if (previousCount < 0) {
        words.forEach((word, index) => {
          word.classList.toggle('is-lit', index < targetCount);
        });
        return targetCount;
      }

      const start = Math.min(previousCount, targetCount);
      const end = Math.max(previousCount, targetCount);

      for (let index = start; index < end; index += 1) {
        words[index].classList.toggle('is-lit', index < targetCount);
      }

      return targetCount;
    };

    if (final) {
      if (!('IntersectionObserver' in window)) {
        setFinalVisible();
      } else {
        const finalObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setFinalVisible();
              finalObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });

        finalObserver.observe(final);
      }
    }

    if (heroPill) {
      const updateHeroPointer = (event) => {
        const rect = heroPill.getBoundingClientRect();
        const x = event.clientX - rect.left - rect.width / 2;
        const softX = x * 0.4;
        root.style.setProperty('--ka-pointer-x', x.toFixed(1));
        root.style.setProperty('--ka-pointer-x-soft', `${softX.toFixed(1)}px`);
      };

      heroPill.addEventListener('pointerenter', () => setHeroHover(true));
      heroPill.addEventListener('pointerleave', () => setHeroHover(false));
      heroPill.addEventListener('pointerout', () => setHeroHover(false));
      heroPill.addEventListener('mouseenter', () => setHeroHover(true));
      heroPill.addEventListener('mouseleave', () => setHeroHover(false));
      heroPill.addEventListener('mouseout', () => setHeroHover(false));
      heroPill.addEventListener('focus', () => setHeroHover(true));
      heroPill.addEventListener('blur', () => setHeroHover(false));
      heroPill.addEventListener('focusin', () => setHeroHover(true));
      heroPill.addEventListener('focusout', () => setHeroHover(false));
      heroPill.addEventListener('pointermove', updateHeroPointer, { passive: true });
      heroPill.addEventListener('mousemove', updateHeroPointer, { passive: true });
    }

    if (finalPill) {
      finalPill.addEventListener('pointerenter', () => setFinalHover(true));
      finalPill.addEventListener('pointerleave', () => setFinalHover(false));
      finalPill.addEventListener('mouseenter', () => setFinalHover(true));
      finalPill.addEventListener('mouseleave', () => setFinalHover(false));
      finalPill.addEventListener('focus', () => setFinalHover(true));
      finalPill.addEventListener('blur', () => setFinalHover(false));
      finalPill.addEventListener('focusin', () => setFinalHover(true));
      finalPill.addEventListener('focusout', () => setFinalHover(false));
    }

    const sectionProgress = (element, viewport, start = 0.86, end = 0.16) => {
      if (!element) return 0;
      const rect = element.getBoundingClientRect();
      const distance = rect.height + viewport * (start - end);
      return clamp((viewport * start - rect.top) / Math.max(distance, 1));
    };

    const storyScrollProgress = (viewport) => {
      if (!storyCopy) return sectionProgress(story, viewport, 0.82, 0.12);
      const rect = storyCopy.getBoundingClientRect();
      const anchor = rect.top + rect.height / 2;
      const start = viewport * 0.88;
      const end = viewport * 0.5;
      return clamp((start - anchor) / Math.max(start - end, 1));
    };

    const update = (now = performance.now()) => {
      ticking = false;
      const viewport = window.innerHeight || document.documentElement.clientHeight || 1;
      const heroRect = hero ? hero.getBoundingClientRect() : null;
      const heroHeight = heroRect ? heroRect.height : 1;
      const heroScrolled = heroRect ? Math.max(0, -heroRect.top) : 0;
      const heroProgress = clamp(heroScrolled / Math.max(heroHeight * 0.58, 1));
      const heroIntroProgress = clamp((now - heroIntroStart) / 1350);
      const heroScrollReveal = heroRect ? clamp(0.18 + heroScrolled / Math.max(heroHeight * 0.34, 1)) : 1;
      const heroReveal = Math.max(heroIntroProgress, heroScrollReveal);
      const storyProgress = storyScrollProgress(viewport);
      const adaptiveProgress = sectionProgress(adaptive, viewport, 0.82, 0.12);
      const serviceProgress = sectionProgress(service, viewport, 0.86, 0.08);
      const proofProgress = sectionProgress(proof, viewport, 0.88, 0.16);

      setMotionValue('--ka-motion-hero', heroProgress);
      setMotionValue('--ka-motion-hero-reveal', heroReveal);
      setMotionValue('--ka-motion-story', storyProgress);
      setMotionValue('--ka-motion-adaptive', adaptiveProgress);
      setMotionValue('--ka-motion-service', serviceProgress);
      setMotionValue('--ka-motion-proof', proofProgress);

      const heroLitCount = Math.ceil(heroWords.length * heroReveal);
      lastHeroLitCount = syncLitWords(heroWords, heroLitCount, lastHeroLitCount);

      const storyLitCount = Math.ceil(storyWords.length * storyProgress);
      lastStoryLitCount = syncLitWords(storyWords, storyLitCount, lastStoryLitCount);

      if (heroIntroProgress < 1) requestUpdate();
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-fish-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ka-fish-marquee')) {
    customElements.define(
      'ka-fish-marquee',
      class KaFishMarquee extends HTMLElement {
        connectedCallback() {
          if (this.isConnectedToMarquee) return;

          this.isConnectedToMarquee = true;
          this.stage = this.querySelector('[data-marquee-stage]');
          this.canvas = this.querySelector('[data-marquee-canvas]');
          this.school = this.querySelector('[data-marquee-school]');

          if (!this.stage || !this.canvas || !this.school) return;

          this.sectionId = this.dataset.sectionId;
          this.speed = Math.max(0, Number.parseFloat(this.dataset.speed) || 0);
          this.direction = this.dataset.direction === 'left' ? -1 : 1;
          this.waveAmplitude = Math.max(0, Number.parseFloat(this.dataset.waveAmplitude) || 0);
          this.waveCycles = Math.max(1, Number.parseFloat(this.dataset.waveCycles) || 1);
          this.configuredGap = Math.max(80, Number.parseFloat(this.dataset.fishGap) || 140);
          this.pauseOnHover = this.dataset.pauseOnHover === 'true';
          this.distance = 0;
          this.frameId = null;
          this.lastFrameTime = null;
          this.isVisible = false;
          this.isPointerPaused = false;
          this.fish = [];

          this.symbolIds = [
            `#ka-fish-lure-${this.sectionId}`,
            `#ka-fish-flying-${this.sectionId}`,
            `#ka-fish-round-${this.sectionId}`,
            `#ka-fish-spotted-${this.sectionId}`
          ];

          this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.handleMotionPreference = () => this.updatePlayback();
          this.handlePointerEnter = () => {
            this.isPointerPaused = true;
            this.updatePlayback();
          };
          this.handlePointerLeave = () => {
            this.isPointerPaused = false;
            this.updatePlayback();
          };
          this.handleFrame = (time) => this.tick(time);

          this.buildFish();
          this.bindObservers();
          this.render();
        }

        bindObservers() {
          if (this.pauseOnHover) {
            this.addEventListener('pointerenter', this.handlePointerEnter);
            this.addEventListener('pointerleave', this.handlePointerLeave);
          }

          if (this.motionQuery.addEventListener) {
            this.motionQuery.addEventListener('change', this.handleMotionPreference);
          } else {
            this.motionQuery.addListener(this.handleMotionPreference);
          }

          if ('IntersectionObserver' in window) {
            this.visibilityObserver = new IntersectionObserver(
              (entries) => {
                this.isVisible = entries[0].isIntersecting;
                this.updatePlayback();
              },
              { rootMargin: '120px 0px', threshold: 0 }
            );
            this.visibilityObserver.observe(this);
          } else {
            this.isVisible = true;
          }

          if ('ResizeObserver' in window) {
            let resizeFrame = null;
            this.resizeObserver = new ResizeObserver(() => {
              if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
              resizeFrame = window.requestAnimationFrame(() => {
                this.buildFish();
                this.render();
              });
            });
            this.resizeObserver.observe(this.stage);
          } else {
            this.handleWindowResize = () => {
              this.buildFish();
              this.render();
            };
            window.addEventListener('resize', this.handleWindowResize, { passive: true });
          }

          this.updatePlayback();
        }

        buildFish() {
          const bounds = this.stage.getBoundingClientRect();
          const width = Math.max(1, Math.round(bounds.width));
          const height = Math.max(1, Math.round(bounds.height));
          const isMobile = width < 750;
          const gap = Math.max(76, this.configuredGap * (isMobile ? 0.72 : 1));
          const overscan = gap * 2;
          const requiredTrackLength = width + overscan * 2;
          const fishCount = Math.ceil(requiredTrackLength / gap) + 1;
          const trackLength = fishCount * gap;
          const svgNamespace = 'http://www.w3.org/2000/svg';

          this.width = width;
          this.height = height;
          this.effectiveWaveAmplitude = this.waveAmplitude * (isMobile ? 0.69 : 1);
          this.gap = gap;
          this.overscan = overscan;
          this.trackStart = -overscan;
          this.trackLength = trackLength;
          this.canvas.setAttribute('viewBox', `0 0 ${width} ${height}`);
          this.school.replaceChildren();
          this.fish = [];

          for (let index = 0; index < fishCount; index += 1) {
            const wrapper = document.createElementNS(svgNamespace, 'g');
            const fishUse = document.createElementNS(svgNamespace, 'use');
            const variant = index % this.symbolIds.length;
            const scalePattern = [0.72, 0.94, 0.64, 0.82, 1, 0.7];
            const scale = scalePattern[index % scalePattern.length] * (isMobile ? 0.86 : 1);

            fishUse.setAttribute('href', this.symbolIds[variant]);
            fishUse.setAttribute('x', '-36');
            fishUse.setAttribute('y', '-16');
            fishUse.setAttribute('width', '72');
            fishUse.setAttribute('height', '32');
            fishUse.setAttribute('class', 'ka-fish-marquee__fish');

            if (this.direction > 0) {
              fishUse.setAttribute('transform', 'scale(-1 1)');
            }

            wrapper.appendChild(fishUse);
            this.school.appendChild(wrapper);

            this.fish.push({
              node: wrapper,
              baseX: -overscan + index * gap,
              scale
            });
          }
        }

        updatePlayback() {
          const shouldAnimate =
            this.isVisible &&
            !this.isPointerPaused &&
            !this.motionQuery.matches &&
            this.speed > 0;

          if (shouldAnimate) {
            this.start();
          } else {
            this.stop();
            this.render();
          }
        }

        start() {
          if (this.frameId !== null) return;
          this.lastFrameTime = null;
          this.frameId = window.requestAnimationFrame(this.handleFrame);
        }

        stop() {
          if (this.frameId !== null) {
            window.cancelAnimationFrame(this.frameId);
            this.frameId = null;
          }
          this.lastFrameTime = null;
        }

        tick(time) {
          if (this.lastFrameTime !== null) {
            const deltaTime = Math.min((time - this.lastFrameTime) / 1000, 0.05);
            this.distance += this.direction * this.speed * deltaTime;
          }

          this.lastFrameTime = time;
          this.render();
          this.frameId = window.requestAnimationFrame(this.handleFrame);
        }

        render() {
          if (!this.fish.length || !this.width || !this.height) return;

          const waveLength = this.width / this.waveCycles;
          const waveFactor = (Math.PI * 2) / waveLength;
          const centerY = this.height / 2;

          this.fish.forEach((fish) => {
            const rawX = fish.baseX + this.distance;
            const x =
              this.trackStart +
              (((rawX - this.trackStart) % this.trackLength) + this.trackLength) %
                this.trackLength;
            const phase = x * waveFactor;
            const y = centerY - Math.sin(phase) * this.effectiveWaveAmplitude;
            const slope = -Math.cos(phase) * this.effectiveWaveAmplitude * waveFactor;
            const rotation = Math.atan(slope) * (180 / Math.PI);

            fish.node.setAttribute(
              'transform',
              `translate(${x.toFixed(2)} ${y.toFixed(2)}) rotate(${rotation.toFixed(2)}) scale(${fish.scale.toFixed(3)})`
            );
          });
        }

        disconnectedCallback() {
          this.stop();
          this.isConnectedToMarquee = false;

          if (this.visibilityObserver) this.visibilityObserver.disconnect();
          if (this.resizeObserver) this.resizeObserver.disconnect();

          if (this.handleWindowResize) {
            window.removeEventListener('resize', this.handleWindowResize);
          }

          if (this.pauseOnHover) {
            this.removeEventListener('pointerenter', this.handlePointerEnter);
            this.removeEventListener('pointerleave', this.handlePointerLeave);
          }

          if (this.motionQuery) {
            if (this.motionQuery.removeEventListener) {
              this.motionQuery.removeEventListener('change', this.handleMotionPreference);
            } else {
              this.motionQuery.removeListener(this.handleMotionPreference);
            }
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ka-on-water-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ka-on-water-videos')) {
    customElements.define(
      'ka-on-water-videos',
      class KaOnWaterVideos extends HTMLElement {
        connectedCallback() {
          this.cards = Array.from(this.querySelectorAll('[data-video-card]'));
          this.activeCard = null;
          this.classList.add('is-enhanced');
          this.setupReveal();
          this.setupVideos();
        }

        setupReveal() {
          if (!('IntersectionObserver' in window)) {
            this.classList.add('is-visible');
            return;
          }

          this.revealObserver = new IntersectionObserver(
            (entries) => {
              if (!entries[0].isIntersecting) return;
              this.classList.add('is-visible');
              this.revealObserver.disconnect();
            },
            { threshold: 0.14 }
          );

          this.revealObserver.observe(this);
        }

        setupVideos() {
          this.cards.forEach((card) => {
            const video = card.querySelector('video');
            const playButton = card.querySelector('[data-video-play]');

            if (!video || !playButton) return;

            video.autoplay = false;
            video.muted = true;
            video.controls = false;
            video.removeAttribute('controls');
            video.pause();

            playButton.addEventListener('click', () => this.playCard(card));
            video.addEventListener('ended', () => this.resetCard(card));
          });
        }

        async playCard(card) {
          this.cards.forEach((otherCard) => {
            if (otherCard !== card) this.resetCard(otherCard);
          });

          const video = card.querySelector('video');
          if (!video) return;

          video.muted = true;
          video.controls = true;
          card.classList.add('is-playing');
          this.activeCard = card;

          try {
            await video.play();
            video.focus({ preventScroll: true });
          } catch (error) {
            this.resetCard(card);
          }
        }

        resetCard(card) {
          const video = card.querySelector('video');
          if (!video) return;

          const shouldRestorePoster =
            card.classList.contains('is-playing') || !video.paused || video.currentTime > 0;

          video.pause();
          video.controls = false;
          video.removeAttribute('controls');

          if (shouldRestorePoster) video.load();

          card.classList.remove('is-playing');

          if (this.activeCard === card) {
            this.activeCard = null;
          }
        }

        disconnectedCallback() {
          if (this.revealObserver) this.revealObserver.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mbs2026-survey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('mbs2026-survey')) return;

    const SHADOW_STYLES = `
      :host([data-mbs-ready]) {
        --inline-container-max-width: 680px;
        --container-max-w: 680px;
        --forms-body-font: normal 400 14px -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        --forms-heading-font: normal 750 36px -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        --forms-base-font-size: 14px;
        --forms-heading-font-size: 36px;
        --body-text-color: #02132a;
        --heading-text-color: #02132a;
        --form-text-color: #02132a;
        --forms-accent-color: #126cae;
        --form-error-color: #ae2635;
        --form-background-color: #fff;
        --container-text-alignment: left;
        --form-field-border-radius: 4px;
        --button-border-radius: 4px;
      }
      [data-mbs-ui], [data-mbs-ui] * { box-sizing: border-box; }
      [data-mbs-ui] [data-sizing="form-wrapper"] {
        width: 100%; max-width: 100%; padding: 0; margin: 0; border: 0; box-shadow: none;
      }
      [data-mbs-content] { min-width: 0; width: 100%; padding: 0 !important; }
      [data-mbs-ui][data-current-step="form"] section:has(form[data-mbs-form]) { overflow: visible; }
      [data-mbs-header] { text-align: left; margin: 0 0 32px; padding: 0; }
      [data-mbs-header] h2 {
        font: 750 clamp(28px, 4vw, 36px)/1.18 -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        color: #02132a; letter-spacing: -1px; margin: 0 0 12px;
      }
      [data-mbs-header] p { margin: 0; color: #536577; font-size: 14px; line-height: 1.65; }
      [data-mbs-ui] form[data-mbs-form] { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px 24px; margin: 0; padding: 0; }
      [data-mbs-ui] form[data-mbs-form] > * { grid-column: 1 / -1; min-width: 0; }
      [data-mbs-ui] form[data-mbs-form] > [data-mbs-contact] { grid-column: auto; margin: 0; }
      [data-mbs-ui] form[data-mbs-form] > [data-mbs-contact="wide"] { grid-column: 1 / -1; }
      [data-mbs-details] { border-top: 1px solid #dce5ed; padding-top: 32px; }
      [data-mbs-details] h3 { margin: 0; color: #02132a; font-size: 19px; line-height: 1.45; font-weight: 650; letter-spacing: -.25px; }
      .mbs-kicker { display: block; margin: 0 0 10px; color: #536577; font-size: 10px; line-height: 1.6; font-weight: 750; letter-spacing: 1.4px; text-transform: uppercase; }
      .mbs-kicker b { margin-right: 10px; color: #126cae; font-weight: 750; }
      [data-mbs-ui] [data-mbs-input-wrap] { display: flex; flex-direction: column; min-width: 0; width: 100%; position: relative; gap: 0; }
      [data-mbs-ui] [data-mbs-label] {
        order: -1; position: static !important; inset: auto !important; transform: none !important;
        display: block; margin: 0 0 7px; padding: 0; width: auto; max-width: none;
        color: #02132a; font: 650 13px/1.6 -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        opacity: 1; pointer-events: auto; white-space: normal;
      }
      [data-mbs-ui] input[data-mbs-input] {
        box-sizing: border-box; display: block; width: 100%; min-width: 0; height: 48px; min-height: 48px; margin: 0;
        padding: 11px 13px; border: 1px solid #b9c8d5; border-radius: 4px; box-shadow: none;
        color: #02132a; background: #fff; font: 400 16px/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        transition: border-color .15s, background .15s, box-shadow .15s;
      }
      [data-mbs-ui] input[data-mbs-input]:hover { border-color: #7797b1; }
      [data-mbs-ui] input[data-mbs-input]:focus { border: 1px solid #126cae; background: #fcfeff; box-shadow: inset 0 0 0 1px #126cae; outline: none; }
      [data-mbs-ui] input[data-mbs-input][aria-invalid="true"] { border: 1px solid #ae2635; box-shadow: inset 0 0 0 1px #ae2635; }
      [data-mbs-ui] [data-mbs-phone] { display: grid; grid-template-columns: minmax(0, 1fr); grid-template-rows: auto 48px; gap: 0; position: relative; }
      [data-mbs-ui] [data-mbs-phone] [data-mbs-input-wrap] { display: contents; }
      [data-mbs-ui] [data-mbs-phone] [data-mbs-label] { grid-area: 1 / 1; }
      [data-mbs-ui] [data-mbs-phone] input[data-mbs-input] { grid-area: 2 / 1; padding-left: 81px; }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector {
        grid-area: 2 / 1; align-self: start; position: relative; top: auto; left: auto;
        width: calc(100% - 2px); height: 46px; margin: 1px; z-index: 2; pointer-events: none;
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector button[aria-expanded] {
        box-sizing: border-box; display: flex; align-items: center; justify-content: center; gap: 8px;
        min-height: 46px; height: 46px; width: 68px; padding: 0 10px; pointer-events: auto;
        border: 0; border-right: 1px solid #dce5ed; border-radius: 3px 0 0 3px; background: transparent; box-shadow: none;
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector button[aria-expanded] > span {
        display: flex; align-items: center; justify-content: center; flex: 0 0 auto; margin: 0; overflow: visible;
      }
      [data-mbs-ui] [data-mbs-phone] #country-selector-value { width: 24px; }
      [data-mbs-ui] [data-mbs-phone] #country-selector-value img { display: block; width: 24px; height: 18px; object-fit: contain; }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector button[aria-expanded="true"] { background: #edf7fe; }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector button[aria-expanded]:focus-visible {
        box-shadow: none; outline: 2px solid #126cae; outline-offset: -3px;
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector div:has(> [role="listbox"]) {
        box-sizing: border-box; width: calc(100% + 2px); left: -1px; z-index: 10; pointer-events: auto;
        max-height: none !important; border: 1px solid #b9c8d5; border-radius: 4px;
        background: #fff; box-shadow: 0 4px 12px rgba(2, 19, 42, .1);
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector [role="listbox"] {
        width: 100%; max-height: min(264px, 40vh) !important; padding: 0 6px;
        overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; scrollbar-gutter: stable; scroll-snap-type: y mandatory;
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector [role="listbox"] > div { margin: 0; box-shadow: none; scroll-snap-align: start; }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector [role="option"] {
        min-height: 44px; padding: 12px 10px; white-space: normal; overflow-wrap: anywhere;
        color: #02132a; font: 400 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
      }
      [data-mbs-ui] [data-mbs-phone] .phone-country-selector [role="option"]:is(:focus, [aria-selected="true"]) {
        background: #edf7fe; outline: 2px solid #126cae; outline-offset: -2px;
      }
      [data-mbs-ui] form output { font-size: 13px; line-height: 1.5; }
      fieldset[data-mbs-group] { width: 100%; min-width: 0; margin: 0; padding: 0; border: 0; }
      fieldset[data-mbs-group="roles"] { margin-top: 12px; }
      fieldset[data-mbs-group] > legend {
        display: block; float: none; width: 100%; max-width: 100%; margin: 0 0 14px; padding: 32px 0 0;
        border-top: 1px solid #dce5ed; color: #02132a;
        font: 650 19px/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif; letter-spacing: -.25px;
      }
      [data-mbs-ui] [data-mbs-options] { display: grid; grid-template-columns: minmax(0, 1fr); gap: 4px; width: 100%; }
      [data-mbs-ui] [data-mbs-group="roles"] [data-mbs-options] { grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 18px; }
      [data-mbs-ui] [data-mbs-option] {
        display: flex; align-items: flex-start; gap: 12px; width: calc(100% + 12px); min-width: 0; min-height: 48px;
        margin: 0 0 0 -12px; padding: 12px; border: 0; border-radius: 4px; box-shadow: none;
        cursor: pointer; transition: background .15s, box-shadow .15s;
      }
      [data-mbs-ui] [data-mbs-option] > span { min-width: 0; color: #02132a; font-size: 14px; line-height: 24px; }
      [data-mbs-ui] [data-mbs-option] input { width: 19px; height: 19px; min-width: 19px; flex: 0 0 19px; margin: 2px 0 0; accent-color: #126cae; cursor: pointer; }
      [data-mbs-ui] [data-mbs-option] > div:has(> input) { display: flex; width: 19px; min-width: 19px; height: 23px; margin: 0; padding: 0; flex: 0 0 19px; }
      [data-mbs-ui] [data-mbs-option]:hover { background: #f5f9fc; }
      [data-mbs-ui] [data-mbs-option]:has(input:checked) { background: #edf7fe; box-shadow: inset 0 0 0 1px #b7d9f1; }
      [data-mbs-ui] [data-mbs-option]:focus-within { outline: 2px solid #4293d5; outline-offset: -2px; }
      [data-mbs-ui] [data-mbs-group="consent"] [data-mbs-option] > span { font-size: 13px; line-height: 1.75; }
      [data-mbs-ui] [role="alert"], [data-mbs-ui] [data-testid="field-error"] { color: #ae2635; font-size: 13px; line-height: 1.5; }
      [data-mbs-ui] form[data-mbs-form] [data-testid="btn-form-submit"] {
        box-sizing: border-box; width: 100%; min-height: 52px; margin-top: 4px; padding: 13px 20px; border: 1px solid #02132a;
        border-radius: 4px; background: #02132a; color: #fff; font-size: 15px; font-weight: 650; line-height: 1.6;
        transition: background .15s, transform .15s;
      }
      [data-mbs-ui] form[data-mbs-form] [data-testid="btn-form-submit"]:hover { background: #113653; }
      [data-mbs-ui] form[data-mbs-form] [data-testid="btn-form-submit"]:active { transform: translateY(1px); }
      [data-mbs-ui] form[data-mbs-form] [data-testid="btn-form-submit"]:is(:disabled, [aria-disabled="true"]) { opacity: .55; cursor: wait; }
      [data-mbs-ui] button:focus-visible, [data-mbs-ui] a:focus-visible { outline: 2px solid #4293d5; outline-offset: -3px; }
      [data-mbs-disclaimer] { margin-top: 16px; padding: 0; color: #536577; text-align: center; font-size: 12px; line-height: 1.7; }
      [data-mbs-disclaimer] p { margin: 0; }
      [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] {
        display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 0;
        min-height: 400px; margin: 0; padding: 42px 16px 56px; border: 0; background: #fff; text-align: center;
        animation: mbs-arrive .24s ease-out; scroll-margin-top: 140px;
      }
      [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] h2 {
        max-width: 550px; margin: 24px 0 18px; color: #02132a;
        font: 750 clamp(27px, 4vw, 34px)/1.3 -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
        letter-spacing: -.7px; text-wrap: balance;
      }
      [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] h2:focus { outline: none; }
      [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] > div:not([data-mbs-success-icon]) {
        max-width: 460px; color: #536577; font-size: 14px; line-height: 1.75;
      }
      [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] p { margin: 0; }
      [data-mbs-success-icon] {
        display: grid; place-items: center; width: 64px; height: 64px; margin: 0; border-radius: 50%;
        background: #edf7fe; color: #126cae; font: 400 32px/1 Arial, sans-serif;
      }
      @keyframes mbs-arrive { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
      @media (max-width: 560px) {
        [data-mbs-ui] form[data-mbs-form] { grid-template-columns: minmax(0, 1fr); gap: 16px; }
        [data-mbs-ui] [data-mbs-group="roles"] [data-mbs-options] { grid-template-columns: minmax(0, 1fr); }
        fieldset[data-mbs-group] { margin-top: 4px; }
        fieldset[data-mbs-group="roles"] { margin-top: 16px; }
        fieldset[data-mbs-group] > legend { font-size: 18px; }
        [data-mbs-ui][data-current-step="success"] [data-testid="banner-success"] { min-height: 360px; padding: 32px 0 40px; }
      }
      @media (prefers-reduced-motion: reduce) {
        [data-mbs-ui] *, [data-mbs-ui] *::before, [data-mbs-ui] *::after { animation: none !important; transition: none !important; scroll-behavior: auto !important; }
      }
    `;

    const GROUPS = [
      ['custom#mbs2026_participant_roles', 'roles', '02'],
      ['custom#mbs2026_titanium_guide_appeal', 'titanium', '03'],
      ['custom#mbs2026_shore_boat_appeal', 'shore_boat', '04'],
      ['custom#mbs2026_entry_consent', 'consent', '05']
    ];

    class MbsSurvey extends HTMLElement {
      connectedCallback() {
        if (this.dataObserver || this.dataset.enhance !== 'true') return;
        this.copy = {};
        this.querySelector('[data-mbs-copy]')?.content.querySelectorAll('[data-copy]').forEach(node => {
          this.copy[node.dataset.copy] = node.textContent.trim();
        });
        this.dataObserver = new MutationObserver(() => this.connectForm());
        this.dataObserver.observe(this, { childList: true, subtree: true });
        this.attempts = 0;
        this.connectForm();
        if (!this.formRoot && !this.retry) this.retry = setInterval(() => {
          this.connectForm();
          if (this.formRoot || ++this.attempts >= 120) {
            clearInterval(this.retry);
            this.retry = null;
          }
        }, 250);
      }

      disconnectedCallback() {
        clearInterval(this.retry);
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.focusFrame);
        this.frame = null;
        this.focusFrame = null;
        this.dataObserver?.disconnect();
        this.shadowObserver?.disconnect();
        this.retry = null;
        this.dataObserver = null;
        this.shadowObserver = null;
        this.formRoot = null;
        this.lastSuccess = null;
      }

      connectForm() {
        const host = this.querySelector('[data-forms-id="forms-root-1158682"] shopify-forms-embed');
        const root = host?.shadowRoot;
        if (!root) {
          if (host && host !== this.host && !this.retry) {
            this.attempts = 0;
            this.retry = setInterval(() => {
              this.connectForm();
              if ((host.shadowRoot && this.formRoot === host.shadowRoot) || ++this.attempts >= 120) {
                clearInterval(this.retry);
                this.retry = null;
              }
            }, 250);
          }
          return;
        }
        if (root === this.formRoot) return;
        this.shadowObserver?.disconnect();
        this.host = host;
        this.formRoot = root;
        clearInterval(this.retry);
        this.retry = null;
        this.shadowObserver = new MutationObserver(() => this.schedule());
        this.shadowObserver.observe(root, {
          childList: true, subtree: true, attributes: true,
          attributeFilter: ['data-current-step']
        });
        this.schedule();
      }

      schedule() {
        if (this.frame || !this.isConnected) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          try { this.decorate(); }
          catch (error) {
            this.shadowObserver?.disconnect();
            this.restore();
            console.warn('MBS2026 styling unavailable; native form remains active.', error.name);
          }
        });
      }

      owned(tag, key, text) {
        const node = document.createElement(tag);
        node.dataset.mbsOwned = key;
        if (text) node.textContent = text;
        return node;
      }

      kicker(key, number) {
        const span = this.owned('span', key);
        span.className = 'mbs-kicker';
        const b = document.createElement('b');
        b.textContent = number;
        span.append(b, document.createTextNode(this.copy[key] || ''));
        return span;
      }

      topChild(form, node) {
        while (node && node.parentElement !== form) node = node.parentElement;
        return node;
      }

      decorate() {
        const root = this.formRoot;
        const app = root.querySelector('[data-current-step]');
        if (!app) return;
        const form = app.querySelector('form[data-testid="form"]');
        const groups = GROUPS.map(([name]) => form?.querySelector(`fieldset[name="${name}"]`));
        const knownForm = form && root.getElementById('last_name') && root.getElementById('email') &&
          root.getElementById('custom#postcode') && groups.every(group => group?.querySelector('legend'));
        const success = app.dataset.currentStep === 'success' && !form && app.querySelector('[data-testid="banner-success"]');
        if (!knownForm && !success) {
          this.restore();
          return;
        }
        if (!root.querySelector('style[data-mbs-owned="style"]')) {
          root.append(this.owned('style', 'style', SHADOW_STYLES));
        }
        this.host.dataset.mbsReady = '';
        app.dataset.mbsUi = '';
        if (knownForm) {
          this.lastSuccess = null;
          this.decorateForm(form, groups);
        }
        if (success) this.decorateSuccess(success, app);
      }

      decorateForm(form, groups) {
        const root = this.formRoot;
        form.dataset.mbsForm = '';
        const header = form.previousElementSibling;
        if (header?.querySelector('h2')) header.dataset.mbsHeader = '';
        form.parentElement.dataset.mbsContent = '';
        if (form.nextElementSibling) form.nextElementSibling.dataset.mbsDisclaimer = '';
        const inputs = ['last_name', 'first_name', 'email', 'phone_number', 'custom#postcode']
          .map(id => root.getElementById(id)).filter(input => input && form.contains(input));
        const fields = inputs.map(input => this.topChild(form, input));
        if (!fields.every(Boolean)) return;
        inputs.forEach((input, index) => {
          fields[index].dataset.mbsContact = inputs.length % 2 && index === inputs.length - 1 ? 'wide' : '';
          input.dataset.mbsInput = '';
          input.parentElement.dataset.mbsInputWrap = '';
          const label = root.getElementById(`label-${input.id}`);
          if (label) label.dataset.mbsLabel = '';
          if (input.id === 'phone_number') fields[index].dataset.mbsPhone = '';
        });
        if (!form.querySelector('[data-mbs-details]')) {
          const details = this.owned('div', 'details');
          details.dataset.mbsDetails = '';
          const title = document.createElement('h3');
          title.textContent = this.copy.details_title;
          details.append(this.kicker('details', '01'), title);
          fields[0].before(details);
        }
        groups.forEach((group, index) => {
          const [, key, number] = GROUPS[index];
          const legend = group.querySelector('legend');
          group.dataset.mbsGroup = key;
          if (!legend.querySelector(`[data-mbs-owned="${key}"]`)) legend.prepend(this.kicker(key, number));
          const options = [...group.children].find(child => child.tagName === 'DIV' && child.querySelector('label input'));
          if (options) {
            options.dataset.mbsOptions = '';
            options.querySelectorAll('label').forEach(label => {
              if (label.querySelector('input[type="checkbox"], input[type="radio"]')) label.dataset.mbsOption = '';
            });
          }
        });
      }

      decorateSuccess(banner, app) {
        const heading = banner.querySelector('h2');
        if (!heading) return;
        if (!banner.querySelector('[data-mbs-success-icon]')) {
          const icon = this.owned('div', 'success-icon', '✓');
          icon.dataset.mbsSuccessIcon = '';
          icon.setAttribute('aria-hidden', 'true');
          heading.before(icon);
        }
        if (this.lastSuccess === banner) return;
        this.lastSuccess = banner;
        heading.setAttribute('tabindex', '-1');
        this.focusFrame = requestAnimationFrame(() => {
          if (!banner.isConnected || app.dataset.currentStep !== 'success') return;
          heading.focus({ preventScroll: true });
          banner.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        });
      }

      restore() {
        if (!this.formRoot) return;
        this.formRoot.querySelectorAll('[data-mbs-owned]').forEach(node => node.remove());
        this.formRoot.querySelectorAll('*').forEach(node => {
          [...node.attributes].filter(attr => attr.name.startsWith('data-mbs-')).forEach(attr => node.removeAttribute(attr.name));
        });
        this.host?.removeAttribute('data-mbs-ready');
        this.lastSuccess = null;
      }
    }

    customElements.define('mbs2026-survey', MbsSurvey);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-with-text-hotspot')) {
    class MediaWithTextHotspot extends HTMLElement {
      connectedCallback() {
        this.toggleButton = this.querySelector('.media-with-text__hotspot-toggle');
        this.card = this.querySelector('.media-with-text__hotspot-card');
        this.mediaWrapper = this.closest('.media-with-text__media-wrapper');
        this.mobileMedia = window.matchMedia('(max-width: 768px)');
        this.handleToggle = this.handleToggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleViewportChange = this.handleViewportChange.bind(this);
        this.fitCard = this.fitCard.bind(this);
        this.toggleButton?.addEventListener('click', this.handleToggle);
        this.card?.addEventListener('click', this.handleCardClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.fitCard);
        this.mobileMedia.addEventListener('change', this.handleViewportChange);
        requestAnimationFrame(this.fitCard);
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.card?.removeEventListener('click', this.handleCardClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('resize', this.fitCard);
        this.mobileMedia?.removeEventListener('change', this.handleViewportChange);
      }

      handleCardClick(event) {
        event.stopPropagation();
      }

      handleToggle(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.mobileMedia.matches) return;
        this.setOpen(!this.classList.contains('is-open'));
      }

      handleDocumentClick(event) {
        if (!this.mobileMedia.matches || !this.classList.contains('is-open')) return;
        if (!this.contains(event.target)) this.setOpen(false);
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          this.setOpen(false);
          this.toggleButton?.focus();
        }
      }

      handleViewportChange() {
        this.setOpen(false);
        requestAnimationFrame(this.fitCard);
      }

      setOpen(isOpen) {
        this.classList.toggle('is-open', isOpen);
        this.toggleButton?.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) requestAnimationFrame(this.fitCard);
      }

      fitCard() {
        if (!this.card || !this.mediaWrapper) return;
        this.classList.remove('media-with-text__hotspot--align-left');
        this.style.setProperty('--hotspot-card-offset', '0px');
        const wrapperRect = this.mediaWrapper.getBoundingClientRect();
        const hotspotRect = this.getBoundingClientRect();
        const cardWidth = this.card.offsetWidth;
        const gutter = 8;

        if (!this.mobileMedia.matches) {
          const dotRadius = 20;
          const connectorLength = 84;
          const desktopCardRight = hotspotRect.left + dotRadius + connectorLength + cardWidth;
          if (desktopCardRight > wrapperRect.right - gutter) {
            this.classList.add('media-with-text__hotspot--align-left');
          }
          return;
        }

        const desiredLeft = hotspotRect.left - (cardWidth / 2);
        const desiredRight = desiredLeft + cardWidth;
        let offset = 0;
        if (desiredLeft < wrapperRect.left + gutter) {
          offset += wrapperRect.left + gutter - desiredLeft;
        }
        if (desiredRight + offset > wrapperRect.right - gutter) {
          offset -= desiredRight + offset - wrapperRect.right + gutter;
        }
        this.style.setProperty('--hotspot-card-offset', `${offset}px`);
      }
    }

    customElements.define('media-with-text-hotspot', MediaWithTextHotspot);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onLayoutResize = this._onLayoutResize.bind(this);
      this._layoutResizeTimer = 0;
    }

    connectedCallback() {
      this.header =
        document.getElementById('shopify-section-mobile-header') ||
        this.closest('.shopify-section-mobile-header');
      if (!this.header) return;
      this.headerSection = this.header.querySelector('.mobile-header');
      if (!this.headerSection) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this._onLayoutResize, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this._onLayoutResize);
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = 0;
    }

    _onLayoutResize() {
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = setTimeout(() => {
        this._layoutResizeTimer = 0;
        if (!this.header || !this.headerSection) return;
        if (!window.matchMedia('(max-width: 920px)').matches) return;
        this.createObserver();
        this.onScrollHandler();
      }, 120);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-mobile-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-mobile-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate');
    }
  }

  customElements.define('mobile-sticky-header', MobileStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nautic-product-detail"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNauticDetail(root) {
    if (!root || root.dataset.nauticFDetailReady === 'true') {
      return;
    }

    root.dataset.nauticFDetailReady = 'true';
    var items = root.querySelectorAll('.nf-detail__reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAllNauticDetails(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    container.querySelectorAll('[data-nautic-f-detail]').forEach(initNauticDetail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllNauticDetails(document);
    });
  } else {
    initAllNauticDetails(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllNauticDetails(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = this.closest('.shopify-section-header');
    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection =
      this.header.querySelector('.secondary-header-section') ||
      this.header.querySelector('.header-section') ||
      this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const primarySticky = document.querySelector('sticky-header');
    const skipGlobalHeaderHeight =
      primarySticky && this.header && !this.header.contains(primarySticky);
    if (!skipGlobalHeaderHeight) {
      const prev = document.documentElement.style.getPropertyValue('--header-height');
      if (prev !== next) {
        document.documentElement.style.setProperty('--header-height', next);
      }
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop <= (hb.bottom + eps)) {
      this._setState('reset');
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ka-hosted-video')) {
    customElements.define('ka-hosted-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('button').addEventListener('click', () => {
          let video = this.querySelector('video');
          if (!video) {
            this.appendChild(this.querySelector('template').content.cloneNode(true));
            video = this.querySelector('video');
          }
          this.querySelector('button').hidden = true;
          video.setAttribute('aria-label', this.dataset.videoLabel);
          video.focus({ preventScroll: true });
          video.play().catch(() => { video.controls = true; });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
